export interface LmdbServerOption {
  id: string;
  label: string;
  apiBaseUrl: string;
}

export const LMDB_SERVER_CONFIG: LmdbServerOption[] = [
  {id: 'server1', label: 'Server 1 (port 9000)', apiBaseUrl: 'http://localhost:9000/v2'},
  {id: 'server2', label: 'Server 2 (port 8000)', apiBaseUrl: 'http://localhost:8000/v2'},
];
